module.exports = __webpack_public_path__ + "img/9788956601571.5c2dec34.jpg";